import { CalendarCustomToolbarWithoutViewSelection, StaffAttendanceOrLeaveModal } from "components";
import { useReducer } from "react";
import { Calendar } from "react-big-calendar";
import { useQuery } from "react-query";
import apiService from "services/api";
import { initialModalState, modalActions, modalReducer } from "./reducers";
import { momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { eventColors, transformAttendance, transformLeaves, mergeEvents } from "./constants";
import { useHistory, Link } from "react-router-dom";

const localizer = momentLocalizer(moment);

const StaffAttendancePage = () => {
	const history = useHistory();
	const staff_id = history.location.pathname.split("/").slice(-1)[0];
	// using history.location because useparams dont seem to work

	const { data: staff } = useQuery(
		["staff", staff_id],
		() =>
			apiService.staff
				.get(staff_id)
				.then((staff) => ({ ...staff, events: [...transformAttendance(staff.attendanceRecords), ...transformLeaves(staff.applications)] })),
		{ enabled: Boolean(staff_id) }
	);

	const [state, dispatch] = useReducer(modalReducer, initialModalState);

	const displayAttendanceDetails = (event) => {
		dispatch({ type: modalActions.OPEN, payload: event });
	};

	return (
		<div className="content">
			<StaffAttendanceOrLeaveModal state={state} dispatch={dispatch} />
			<h5 className="text-center font-weight-bold">{staff?.fullName}'s Attendance Records</h5>
			<div>
				<Link to={`/staff/attendance`}>
					<button type="button" className="btn btn-info btn-sm">
						&lt; Back
					</button>
				</Link>
			</div>
			<div className="row">
				<div className="col-12" style={{ height: 500 }}>
					<Calendar
						selectable
						localizer={localizer}
						longPressThreshold={200}
						events={staff?.events || []}
						defaultView="month"
						defaultDate={new Date()}
						eventPropGetter={eventColors}
						onSelectEvent={displayAttendanceDetails}
						dayLayoutAlgorithm="no-overlap"
						components={{ toolbar: CalendarCustomToolbarWithoutViewSelection }}
						popup
						messages={{
							showMore: (total) => (
								<div
									style={{ cursor: "pointer" }}
									className="text-center"
									onMouseOver={(e) => {
										e.preventDefault();
									}}
								>
									{`+${total}`}
								</div>
							),
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default StaffAttendancePage;
